// extracted by mini-css-extract-plugin
module.exports = {"timer":"Timer_timer__1_mjp"};